// extracted by mini-css-extract-plugin
export default {"wrapper":"xCJsIYPLJ2Mf18zfZIAF"};